'use strict';
import Translator from 'gettext-translator';
import translations from 'app/translations.json';

export default new Translator(translations)
